import React from 'react';
import { DonutLegendChart } from '@/components/ui/DonutLegendChart';

export function ProjectTasksStats() {
  const statsData = [
    { name: 'Hoàn thành', value: 10, color: '#10b981' },
    { name: 'Đang thực hiện', value: 12, color: '#3b82f6' },
    { name: 'Chưa bắt đầu', value: 8, color: '#94a3b8' },
    { name: 'Quá hạn', value: 2, color: '#f43f5e' },
  ];

  return (
    <div className="space-y-6">
      {/* Biểu đồ Donut */}
      <DonutLegendChart
        title="Tổng quan công việc"
        centerValue={32}
        centerLabel="Tổng công việc"
        data={statsData}
        total={32}
      />

      {/* Tiến độ công việc */}
      <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
        <h3 className="text-sm font-normal text-slate-900">Tiến độ công việc</h3>
        <div className="space-y-2">
             <div className="flex justify-between items-end">
                <span className="text-2xl font-normal text-slate-900 leading-none">45%</span>
                <span className="text-xs font-normal text-slate-400">Đang thực hiện</span>
             </div>
          <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
            <div className="h-full bg-emerald-500 transition-all duration-700" style={{ width: '45%' }} />
          </div>
          <p className="text-xs text-slate-400">Cập nhật: 15/05/2024 09:30</p>
        </div>
      </div>
    </div>
  );
}
